import {
  AD_STATUS_ACTIVE,
  AD_STATUS_AWAITING_APPROVAL,
  AD_STATUS_COMPLETED,
  AD_STATUS_CREATED,
  AD_STATUS_DECLINED,
  AD_STATUS_PAUSED,
  AD_STATUS_PENDING,
  AD_STATUS_RUNNING,
  CAMPAIGN_STATUS_ACTIVE,
  CAMPAIGN_STATUS_COMPLETED,
  CAMPAIGN_STATUS_CREATED,
  CAMPAIGN_STATUS_PAUSED,
  CAMPAIGN_STATUS_PENDING,
  CAMPAIGN_APPROVAL_STATUS_APPROVED,
  CAMPAIGN_APPROVAL_STATUS_PENDING,
  CAMPAIGN_APPROVAL_STATUS_REJECTED,
} from '@/constants';

/**
 * Get status chip by ad status
 *
 * @param {string} status
 * @param {string} campaignStatus
 * @returns {Object} chip
 * @returns {string} chip.class
 * @returns {string} chip.value
 */
export const getAdStatusChip = (status, campaignStatus) => {
  switch (status) {
    case AD_STATUS_CREATED:
      return {
        class: 'bg-light-blue text-blue-500',
        value: 'Created',
      };
    case AD_STATUS_PENDING:
      // fall through
    case AD_STATUS_AWAITING_APPROVAL:
      return {
        class: 'bg-yellow-100 text-yellow-600',
        value: 'Pending',
      };
    case AD_STATUS_ACTIVE:
      // fall through
    case AD_STATUS_RUNNING:
      return {
        class: 'bg-light-green text-green-500',
        value: 'Running',
      };
    case AD_STATUS_PAUSED:
      return {
        class: 'bg-light-orange text-orange-500',
        value: campaignStatus === CAMPAIGN_STATUS_PAUSED ? 'Advertiser Paused' : 'Paused',
      };
    case AD_STATUS_COMPLETED:
      return {
        class: 'bg-gray-100 text-gray-500',
        value: 'Completed',
      };
    case AD_STATUS_DECLINED:
      return {
        class: 'bg-red-100 text-red-500',
        value: 'Declined',
      };
    default:
      // do nothing
  }

  if (status) {
    return {
      class: '',
      value: status,
    };
  }

  return {
    class: '',
    value: 'Unknown',
  };
};

/**
 * Get status chip by campaign status
 *
 * @param {string} status
 * @returns {Object} chip
 * @returns {string} chip.class
 * @returns {string} chip.value
 */
export const getCampaignStatusChip = (status) => {
  switch (status) {
    case CAMPAIGN_STATUS_CREATED:
      return {
        class: 'bg-light-blue text-blue-500',
        value: 'Created',
      };
    case CAMPAIGN_STATUS_PENDING:
      return {
        class: 'bg-yellow-100 text-yellow-600',
        value: 'Pending',
      };
    case CAMPAIGN_STATUS_ACTIVE:
      return {
        class: 'bg-light-green text-green-500',
        value: 'Active',
      };
    case CAMPAIGN_STATUS_PAUSED:
      return {
        class: 'bg-light-orange text-orange-500',
        value: 'Paused',
      };
    case CAMPAIGN_STATUS_COMPLETED:
      return {
        class: 'bg-gray-100 text-gray-500',
        value: 'Completed',
      };
    default:
      // do nothing
  }

  return {
    class: '',
    value: 'Unknown',
  };
};

export const getCampaignApprovalStatusChip = (status) => {
  switch (status) {
    case CAMPAIGN_APPROVAL_STATUS_APPROVED:
      return {
        class: 'bg-green-100 text-green-600',
        value: 'Approved',
      };
    case CAMPAIGN_APPROVAL_STATUS_PENDING:
      return {
        class: 'bg-yellow-100 text-yellow-600',
        value: 'Pending',
      };
    case CAMPAIGN_APPROVAL_STATUS_REJECTED:
      return {
        class: 'bg-red-100 text-red-600',
        value: 'Rejected',
      };
    default:
      return {
        class: '',
        value: status,
      };
  }
};
